import { render } from "./SignupForm.vue?vue&type=template&id=54345552&bindings={\"displayName\":\"setup\",\"email\":\"setup\",\"password\":\"setup\",\"handleSubmit\":\"setup\",\"error\":\"setup\"}"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script